import React from 'react'

//UI
import { Box } from '@chakra-ui/react'
import VendorDetailForm from '../components/VendorDetailForm'

//API

const AdminVendorCreatePage = () => {
  return (
    <Box shadow="md" borderWidth="1px" bg="white" w="100%" mb="auto" p={5}>
      <VendorDetailForm requestorEmail={''} vendor={{}} isCreate={true} isAdmin={true}></VendorDetailForm>
    </Box>
  )
}

export default AdminVendorCreatePage
